// extracted by mini-css-extract-plugin
export default {"wrapper":"P5-z","play":"Q5-z"};